/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { rethrowError } from 'UIComponents/core/PromiseHandlers';
export default class TextLayerDecorator extends Component {
  constructor(...args) {
    super(...args);

    this.loadTextLayerBuilder = () => {
      return import(
      /* webpackChunkName: "pdf-js" */
      '../../lib/pdf-js').then(({
        TextLayerBuilder
      }) => TextLayerBuilder);
    };

    this.renderTextContent = TextLayerBuilder => {
      const {
        pageObject,
        pageIndex,
        viewport
      } = this.props;
      const textViewport = viewport.retinaScale === 1 ? viewport : pageObject.getViewport({
        scale: viewport.scale / viewport.retinaScale
      });
      const textLayerFactory = new TextLayerBuilder.DefaultTextLayerFactory();
      const textLayerBuilder = textLayerFactory.createTextLayerBuilder(this.textLayer, pageIndex, textViewport, true);
      const height = textViewport.height;
      const width = textViewport.width; // TODO: disable on smaller screens

      this.textLayer.style.height = `${height}px`;
      this.textLayer.style.width = `${width}px`;
      pageObject.getTextContent().then(textContent => {
        textLayerBuilder.setTextContent(textContent);
        textLayerBuilder.render();
      }).catch(rethrowError);
    };
  }

  componentDidMount() {
    this.loadTextLayerBuilder().then(this.renderTextContent);
  }

  componentDidUpdate() {
    this.loadTextLayerBuilder().then(this.renderTextContent);
  }

  render() {
    return /*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      className: "display-flex align-center justify-center",
      children: /*#__PURE__*/_jsx("div", {
        className: "text-layer",
        ref: c => this.textLayer = c
      })
    });
  }

}
TextLayerDecorator.propTypes = {
  pageObject: PropTypes.object.isRequired,
  viewport: PropTypes.object.isRequired,
  pageIndex: PropTypes.number.isRequired
};